import { render } from "./Layout.vue?vue&type=template&id=2f6ef22e"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
script.render = render

export default script